/**
 * @file モーダル
 *
 */
'use strict';

/**
 * @classname ModalView
 * @classdesc モーダル
 */
export default class ModalView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('ModalView.constructor');
		this._$e = $e;
		const target = $e.attr('data-target');
		this._$target = $(target);
		console.log(this._$target);
		this._$body = $('body');
		$e.on('click', () => this.onClick());
		this._$target.on('click', () => this.modalClose());
		this._$target.find('[data-dismiss=modal]').on('click', () => this.modalClose());
		this._$target.find('.modal__dialog').on('click', () => this.modalClose());
		this._$target.find('.modal__dialog__content').on('click', () => this.modalClose());
		this._$target.find('.modal__dialog__content__header').on('click', (e) => {
			e.preventDefault;
			e.stopPropagation();
		});
		this._$target.find('.modal__dialog__content__body').on('click', (e) => {
			e.preventDefault;
			e.stopPropagation();
		});
		this._$target.find('.modal__dialog__content__footer').on('click', (e) => {
			e.preventDefault;
			e.stopPropagation();
		});
	};

	/**
	 * Clickのコールバック
	 *
	 * @memberof ModalView
	 * @return {undefined}
	 */
	onClick() {
		console.log('ModalView.onClick');
		this._$body.css('overflow', 'hidden');
		this._$target.addClass('show');
		this._$body.append('<div class="modal-bg"></div>');

	}

	/**
	 * モーダルを閉じる
	 *
	 * @memberof ModalView
	 * @return undefined
	 */
	modalClose() {
		console.log(`${this.constructor.name}.modalClose`);
		this._$body.removeAttr('style');
		this._$target.removeClass('show');
		const video = this._$target.find('video')[0];
		console.log(video);
		video.load();
	};
}
